export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const DELETE_CART = 'DELETE_CART';
export const EMPTY_CART = 'EMPTY_CART';
export const ADD_TO_CART = 'ADD_TO_CART';
export const FETCH_REMOTE_CART = 'FETCH_REMOTE_CART';

export const FETCH_FILTERED_PRODUCTS = 'products/fetchFilteredProducts';

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const LOG_IN_USER = 'LOG_IN_USER';
export const LOG_OUT_USER = 'LOG_OUT_USER';
export const SAVE_CHECKOUT_ADDRESS = 'user/saveUserInfo';
export const SAVE_ZOOM_LEVEL = 'checkout/setZoomLevel';
export const SAVE_SHIPPING_QUOTE = 'checkout/saveQuote'
export const REFRESH_SESSION = 'REFRESH_SESSION_USER';

export const CREATE_CHECKOUT = 'CREATE_CHECKOUT';
export const DELETE_CHECKOUT = 'DELETE_CHECKOUT';

export const ADD_IMAGE_TO_STATE = 'ADD_IMAGE_TO_STATE';
export const REMOVE_UPLOADED_IMAGE = 'REMOVE_UPLOADED_IMAGE';
export const REMOVE_ALL_UPLOADED_IMAGES = 'REMOVE_ALL_UPLOADED_IMAGES';
